<script>
export default {

};
</script>

<template>
  <a href="" class="flex items-center text-left mb-2">
    <img
      class="resto-logo"
      src="@assets/images/logo.png"
      alt="Logo"
      height="100%"
      width="200"
    />
  </a>
</template>

<style>
    @media (max-width: 992px) {
      .resto-logo {
        max-width: 85%;
      }
    }
</style>
